// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-transfer-type-box {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 200px;
  min-height: 45rem;
  gap: 3rem;
  flex-basis: 50%;
  cursor: pointer;
}
.catalog-transfer-type-box__icon {
  width: 40px;
  height: 40px;
  margin-bottom: 0;
}
.catalog-transfer-type-box__heading {
  margin: 0;
}
.catalog-transfer-type-box__content {
  width: 100%;
}
.catalog-transfer-type-box ul li {
  padding-bottom: 0;
  list-style-position: inside;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/CatalogTransfer/CatalogTransferTypeBox/index.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AACJ;AAEE;EACE,SAAA;AAAJ;AAGE;EACE,WAAA;AADJ;AAKI;EACE,iBAAA;EACA,2BAAA;AAHN","sourcesContent":[".catalog-transfer-type-box {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 200px;\n  min-height: 45rem;\n  gap: 3rem;\n  flex-basis: 50%;\n  cursor: pointer;\n\n  &__icon {\n    width: 40px;\n    height: 40px;\n    margin-bottom: 0;\n  }\n\n  &__heading {\n    margin: 0;\n  }\n\n  &__content {\n    width: 100%;\n  }\n\n  ul {\n    li {\n      padding-bottom: 0;\n      list-style-position: inside;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
